import firebase from '../../firebase'
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore'

const updateDevice = () => {
  const updateDeviceBasedOnId = async (deviceId, deviceType, userId) => {
    console.log(`Updating device ${deviceId} with type ${deviceType} for user ${userId}`)
    try {
      const devicesDocRef = doc(firebase.db, 'devices', deviceId)
      const deviceDocSnap = await getDoc(devicesDocRef)
      const deviceTypesDocRef = doc(firebase.db, 'deviceTypes', deviceType)

      const deviceTypeDocSnap = await getDoc(deviceTypesDocRef)
      let sensors
      if (deviceTypeDocSnap.exists()) {
        sensors = deviceTypeDocSnap.data().sensors || []
      } else {
        console.error(`Device type ${deviceType} does not exist`)
        return
      }
      const deviceData = {
        deviceType: deviceType,
        sensors: sensors,
        type: '',
        userId: userId
      }
      if (userId) {
        deviceData.userId = userId
      }
      if (!deviceDocSnap.exists()) {
        // Document doesn't exist, create a new one
        // Create a new document in devices collection
        await setDoc(devicesDocRef, deviceData)
      } else {
        // Document exists, update it
        await updateDoc(devicesDocRef, {
          deviceType: deviceType,
          sensors: sensors
        })
      }
    } catch (error) {
      console.error('Error updating/creating device:', error)
    }
  }

  return { updateDeviceBasedOnId }
}

export default updateDevice
